<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <span :class="$style.icon"></span>
      <span :class="$style.logo">{{title}}</span>
      <div v-if="$slots.default" :class="$style.right">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WhiteHeader',
  props: {
    title: String,
  },
}
</script>
<style lang="scss" module>
@import './WhiteHeader.scss';
</style>
